<template>
  <div id="app" class="mui-container">  
    <router-view/>
  </div>
</template>

<script>
import store from '@/store'

export default {
  name: 'app'
}
</script>

<style>
#app {
  font-family: Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #808080;
}
</style>



// WEBPACK FOOTER //
// App.vue?326edb5b